import { useNavigate } from 'react-router-dom'
import { FaFolder } from 'react-icons/fa'
import { BeatLoader } from 'react-spinners'
import useMyFileGrants from '../../hooks/useMyFileGrants'

// Dashboard "Private" section: the private folders shared with this user,
// each linking into the read-only file browser.
export default function PrivateFilesCard() {
  const navigate = useNavigate()
  const { prefixes, hasGrants, loading } = useMyFileGrants()

  if (!loading && !hasGrants) return null

  return (
    <div className="bg-white rounded-[10px] border border-gray-200 p-5 mt-6 font-montserrat">
      <h2 className="text-lg font-semibold text-[#2b364b] m-0 mb-1">Private</h2>
      <p className="text-sm text-gray-500 m-0 mb-4">
        Folders shared with you — click one to browse and download its files.
      </p>

      {loading ? (
        <div className="flex items-center justify-center py-6">
          <BeatLoader color="#2b364b" size={8} />
        </div>
      ) : (
        <div className="flex flex-wrap gap-3">
          {prefixes.map(prefix => (
            <button
              key={prefix}
              type="button"
              onClick={() => navigate('/file-browser', { state: { prefix } })}
              className="flex items-center gap-2 px-4 py-3 rounded-lg border border-gray-200 bg-gray-50 hover:bg-[#DEE6F0] cursor-pointer text-sm text-[#2b364b] font-medium"
            >
              <FaFolder className="text-[#8ba3c7]" size={16} />
              <span className="break-all">{prefix.slice(0, -1)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
